import headerWidget from "../../core/chrome/headerWidget.js";

/**
 *
 * `externalHeaderWidget` is a dedicated header for external pages.
 * Unless its parent, `externalHeaderWidget` can be set visible or not
 * since not all the documents in external have a header.
 *
 * The rendering is also a bit different since there is no navigation
 * menu on the left.
 *
 * @param {{}} spec - Parameter object
 * @param {{}} my - protected fields holder
 * @return {*}
 */
function externalHeaderWidget(spec, my) {
	spec ||= {};
	my ||= {};

	const that = headerWidget(spec, my);
	let isVisible = false;

	that.setDocument = function (newDocument) {
		isVisible = newDocument.showHeader;
		my.setDocument(newDocument);
	};

	that.isVisible = function () {
		return isVisible;
	};

	that.renderContentOn = function (html) {
		if (!isVisible) {
			return;
		}

		my.renderAdminBarOn(html);
	};

	return that;
}

export default externalHeaderWidget;
